import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Qikan from '@/components/Qikan'
import Publish from '@/components/Publish'
import Contact from '@/components/Contact'
import User from '@/components/User'
import Notice from '@/components/Notice'
Vue.use(Router)

export default new Router({
  linkExactActiveClass:'link-active',
  routes: [
    // {
    //   path: '/',
    //   name: 'Index',
    //   component: Index
    // },
	{
	  path: '/',
	  name: 'Qikan',
	  component: Qikan
	},
    {
      path: '/Qikan',
      name: 'Qikan',
      component: Qikan
    },
    {
      path: '/Publish',
      name: 'Publish',
      component: Publish
    },
    {
      path: '/Contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/User',
      name: 'User',
      component: User
    },
    {
      path: '/Notice',
      name: 'Notice',
      component: Notice
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js